<template>
  <el-dialog title="添加学员信息" :visible.sync="modalShow" append-to-body>
    <el-form ref="filter" :model="filter"  size="small" inline>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="filter.phone" placeholder="请输入手机号" clearable />
      </el-form-item>
      <el-form-item label=" " label-width="100px">
        <el-button type="primary" size="small" @click="search()">查询</el-button>
        <el-button type="primary" size="small" @click="reset('filter')">重置</el-button>
        <el-button type="primary" size="small" @click="submit()">加入</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="data" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" width="55" :selectable="checkSelectable" />
      <el-table-column label="用户昵称" align="center" prop="nickname" min-width="180" :formatter="fliteRData" />
      <el-table-column label="用户手机号" align="center" prop="phone" min-width="180">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="邮箱" align="center" prop="email" min-width="180" :formatter="fliteRData" />
      <el-table-column label="性别" align="center" prop="sex" min-width="180">
        <template v-slot="{ row }">
          {{sexObj[row.sex]}}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="insertDate" min-width="180" :formatter="fliteRData" />
      <el-table-column label="创建者" align="center" prop="insertByUserName" min-width="180" :formatter="fliteRData" />
      <el-table-column label="更新人员" align="center" prop="updateByUserName" min-width="180" :formatter="fliteRData" />
      <el-table-column label="更新时间" align="center" prop="lastUpdateDate" min-width="180" :formatter="fliteRData" />
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="modalShow = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submit(false)">确 定</el-button>
    </span>
    <!-- 原因 -->
    <reasonMoudel ref="delReason" @submit="submit" />
  </el-dialog>
</template>

<script>
import tableMixins from "@/libs/mixins/table"
import reasonMoudel from "./reasonMoudel"
import { getListPage } from "@/api/product/base"
import { getAppUserInfo } from "@/api/common";

import {
  addsClassStudent,
  queryStudentStatus
} from '@/api/product/classManage'
const sexObj = {
  1:'男',
  2:'女',
  'undefined':'---'
}
export default {
  components: { reasonMoudel },
  mixins:[tableMixins],

  data () {
    return {
      modalShow: false,
      sexObj,
      filter: {
        phone: '',
      },
      data: [],
      loading: false,
      checkedIds: [],
      selectIds: []
    }
  },
  methods: {
    async getData () {
      this.loading = true
      const params = {
        ...this.pageInfo,
        userType: 1,
        ...this.filter
      }
      const res = await getListPage(params)
      if (res.code === 0 && res.data && res.data.records) {
        const userIds = res.data.records.map(item => item.id)
        this.data = res.data.records
        this.total = Number(res.data.total)
        await queryStudentStatus({ skuId: this.$attrs.skuId, userIds })
          .then(({ code, data }) => {
            if (code === 0 && data) {
              this.checkedIds = data
            }
          })
      }
      this.loading = false
    },
    init () {
      this.modalShow = true
      this.getData()
    },
    search () {
      this.getData()
    },

    async submit (isfirst, value) {
      if (!isfirst) {
        if (this.selectIds.length === 0) {
          this.$message.warning('至少选择一个学员后操作!')
          return
        }
        this.$refs.delReason.init()
        return
      }
      const userSkus = this.selectIds.map(item=>{
        return {
          userId: item,
          addReason: value.reason,
          remarks: value.remarks,
          skuId: this.$attrs.skuId,
          companyId: this.$attrs.companyId
        }
      })
      await addsClassStudent(userSkus)
      this.$message.success('添加成功，请点击“查询”刷新列表数据!')
      this.modalShow = false
      this.$emit('update',true)
    },
    checkSelectable (row) {
      return !this.checkedIds.includes(row.id)
    },
    handleSelectionChange (val) {
      this.selectIds = val.map(item => item.id)
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.id }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
